var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.6 0.5 0 4.325 0 9C0 13.675 3.6 17.5 8 17.5C12.4 17.5 16 13.675 16 9C16 4.325 12.4 0.5 8 0.5ZM8 2.625C11.32 2.625 14 5.4725 14 9C14 12.5275 11.32 15.375 8 15.375C4.68 15.375 2 12.5275 2 9C2 5.4725 4.68 2.625 8 2.625ZM7 4.75V9.4675L7.32 9.74375L8.32 10.8062L9 11.6138L10.44 10.0838L9.68 9.36125L9 8.63875V4.7925H7V4.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.43696c395b0b93fa87e79353e232f19d.svg";
export { ForwardRef as ReactComponent };